function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* script */
import { isSameTypeVNode } from '@cloud-sn/v-utils';
import TabBar from './tabBar.js';
import TabContent from './tabContent.js';
var __vue_script__ = {
  name: 'Tabs',
  provide: function provide() {
    return {
      tabRoot: this
    };
  },
  components: {
    TabContent: TabContent,
    TabBar: TabBar
  },
  props: {
    prefixCls: {
      type: String,
      default: 'v-tabs'
    },
    tabBarPosition: {
      type: String,
      default: 'top'
    },
    value: {
      type: String,
      default: undefined
    },
    destroyInactiveTabPane: {
      type: Boolean,
      default: false
    },
    animated: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: 'default'
    },
    control: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      init: false,
      descendants: [],
      activeName: '',
      tabs: []
    };
  },
  computed: {
    classes: function classes() {
      var _ref;

      var prefixCls = this.prefixCls,
          tabBarPosition = this.tabBarPosition;
      return _ref = {}, _defineProperty(_ref, prefixCls, true), _defineProperty(_ref, "".concat(prefixCls, "-").concat(tabBarPosition), true), _ref;
    }
  },
  watch: {
    value: function value(nVal) {
      this.setActiveName(nVal);
    },
    descendants: function () {
      var descendants = this.descendants,
          init = this.init,
          activeName = this.activeName,
          getTabs = this.getTabs; // http://opensource.cnsuning.com/uxcool/lerna-uxcool/issues/236
      // trigger render

      getTabs();

      if (descendants.length === 0) {
        return;
      }

      if (!init) {
        if (!activeName) {
          // 默认选择第一项
          var _descendants$filter = descendants.filter(function (v) {
            return !v.disabled;
          }),
              _descendants$filter2 = _slicedToArray(_descendants$filter, 1),
              descendant = _descendants$filter2[0];

          descendant = descendant || descendants[0];

          if (descendant) {
            this.setActiveName(descendant.name);
          }
        }

        this.init = true;
      }
    }
  },
  created: function created() {
    this.activeName = this.value;
    var getTabs = this.getTabs;
    getTabs(); // slot不是响应式的，利用事件通知父组件重新调render函数渲染
    // http://opensource.cnsuning.com/uxcool/lerna-uxcool/issues/218

    this.$on('tab-update', function () {
      getTabs();
    });
  },
  methods: {
    getTabs: function getTabs() {
      var descendants = this.descendants;
      this.tabs = descendants.map(function (v, i) {
        return {
          idx: i,
          isActive: v.isActive,
          disabled: v.disabled,
          tab: v.$slots.tab || v.tab,
          name: v.name,
          vm: v
        };
      });
    },
    setActiveName: function setActiveName(name) {
      this.activeName = name;
    },
    addDescendant: function addDescendant(item) {
      var $slots = this.$slots;
      var slotDefault = $slots.default;
      var $vnode = item.$vnode;

      while ($vnode.parent) {
        $vnode = $vnode.parent;
      } // http://opensource.cnsuning.com/uxcool/lerna-uxcool/issues/188


      var filterDescendants = slotDefault.filter(function (node) {
        return isSameTypeVNode(node, 'isTabPane');
      });
      var idx = filterDescendants.indexOf($vnode);
      this.descendants.splice(idx, 0, item);
    },
    removeDescendant: function removeDescendant(item) {
      this.descendants = this.descendants.filter(function (v) {
        return v !== item;
      });
    },
    onTabClick: function onTabClick(tab, name, e) {
      var control = this.control;

      if (!control) {
        this.setActiveName(name);
      }

      this.$emit('tab-click', tab, name, e);
    },
    onPrevClick: function onPrevClick(e) {
      this.$emit('prev-click', e);
    },
    onNextClick: function onNextClick(e) {
      this.$emit('next-click', e);
    }
  },
  render: function render() {
    var h = arguments[0];
    var prefixCls = this.prefixCls,
        classes = this.classes,
        tabBarPosition = this.tabBarPosition,
        size = this.size,
        onTabClick = this.onTabClick,
        onPrevClick = this.onPrevClick,
        onNextClick = this.onNextClick,
        animated = this.animated,
        $slots = this.$slots,
        tabs = this.tabs;
    var defaultSlot = $slots.default,
        tabBarExtraContent = $slots.tabBarExtraContent;
    var tabBar = h("tab-bar", {
      "attrs": {
        "prefixCls": prefixCls,
        "tabs": tabs,
        "tabBarPosition": tabBarPosition,
        "extraContent": tabBarExtraContent,
        "size": size
      },
      "on": {
        "tab-click": onTabClick,
        "prev-click": onPrevClick,
        "next-click": onNextClick
      }
    });

    var _tabs$filter = tabs.filter(function (v) {
      return v.isActive;
    }),
        _tabs$filter2 = _slicedToArray(_tabs$filter, 1),
        activeTab = _tabs$filter2[0];

    var activeIdx = -1;

    if (activeTab) {
      activeIdx = activeTab.idx;
    }

    var tabContent = h("tab-content", {
      "attrs": {
        "prefixCls": prefixCls,
        "animated": animated,
        "tabBarPosition": tabBarPosition,
        "activeIdx": activeIdx
      }
    }, [defaultSlot]);
    var childrens = tabBarPosition === 'bottom' ? [tabContent, tabBar] : [tabBar, tabContent];
    return h("div", {
      "class": classes
    }, [childrens]);
  }
};
/* template */

/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = undefined;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "tabs.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;
  return component;
}
/* style inject */

/* style inject SSR */


export default __vue_normalize__({}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);